import React, { FC } from 'react';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { ESGImpactHexBorderMap, ESGImpactHexCodesMap } from 'shared/constants/ESGImpactHexCodesMap';

const useStyles = makeStyles({
  root: {
    borderRadius: 10,
    width: 20,
    height: 10,
    background: 'red',
  },
});

type LegendColorChipProps = {
  chipColor?: string;
  impactLevel?: 'insignificant' | 'veryLow' | 'low' | 'medium' | 'high' | 'veryHigh';
  className?: string;
};

export const LegendColorChip: FC<LegendColorChipProps> = ({
  chipColor,
  impactLevel,
  className,
}) => {
  const classes = useStyles();
  const classNames = clsx(classes.root, className);
  const style = {
    backgroundColor: impactLevel ? ESGImpactHexCodesMap[impactLevel] : chipColor,
    border: impactLevel ? ESGImpactHexBorderMap[impactLevel] : '',
  };

  return <div className={classNames} style={style} />;
};
